import React, { forwardRef } from 'react';

import greyArrow from '../../images/down-arrow-grey.svg';
import whiteArrow from '../../images/down-arrow-white.svg';
import blackFilterIcon from '../../images/Filter Icon.svg';
import whiteFilterIcon from '../../images/whiteFilterIcon.svg';

import { Button } from './styles';

interface Props {
  children: React.ReactNode;
  active: boolean;
  icon: string;
  dataTestId: string;
}

const IconButton = forwardRef(
  (
    {
      children,
      active = false,
      icon = 'arrow',
      dataTestId = 'icon-button',
      ...props
    }: Props,
    ref,
  ) => (
    <Button
      active={active}
      {...props}
      ref={ref}
      data-testid={dataTestId}
    >
      {children}
      {icon === 'arrow' && (
      <img
        src={active ? whiteArrow : greyArrow}
        alt=""
        data-testid="icon-button-arrow"
      />
      )}
      {icon === 'greyArrow' && (
      <img src={greyArrow} alt="" data-testid="icon-grey-arrow" />
      )}
      {icon === 'filter' && (
      <img
        src={active ? whiteFilterIcon : blackFilterIcon}
        alt=""
        data-testid="icon-button-filter"
      />
      )}
    </Button>
  ),
);

export default IconButton;
